import { PublicKey } from '@solana/web3.js';
import { getSolanaConnection } from '../connection';
import { ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID } from '../program/mayhemProgram';
import { formatTokenBalance } from '../utils/tokenBalanceFormat';

function deriveAssociatedTokenAddress(owner, mint) {
  const [publicKey] = PublicKey.findProgramAddressSync(
    [owner.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), mint.toBuffer()],
    ASSOCIATED_TOKEN_PROGRAM_ID
  );

  return publicKey;
}

export async function fetchCurrentRoundTokenBalance(walletPublicKey, currentGameState) {
  if (!walletPublicKey) {
    throw new Error('Wallet public key is required.');
  }

  if (!currentGameState?.mint) {
    return {
      ataPubkey: '',
      amountAtomic: '0',
      displayAmount: '0',
    };
  }

  const connection = getSolanaConnection();
  const owner = new PublicKey(walletPublicKey);
  const mint = new PublicKey(currentGameState.mint);
  const ataPubkey = deriveAssociatedTokenAddress(owner, mint);
  const ataAccountInfo = await connection.getAccountInfo(ataPubkey, 'confirmed');

  if (!ataAccountInfo) {
    return {
      ataPubkey: ataPubkey.toBase58(),
      amountAtomic: '0',
      displayAmount: formatTokenBalance('0', currentGameState.decimals),
    };
  }

  const tokenBalance = await connection.getTokenAccountBalance(ataPubkey, 'confirmed');
  const amountAtomic = tokenBalance.value.amount || '0';

  return {
    ataPubkey: ataPubkey.toBase58(),
    amountAtomic,
    displayAmount: formatTokenBalance(amountAtomic, currentGameState.decimals),
  };
}